export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_04.dec1a69f.jpg";